import type { CardBrandId } from "@libs/utils/card-brands";
import type { Buyer } from "@libs/identity-onboarding-contracts/buyer";
import type { CaptureComplete, CardCapture } from "@libs/identity-onboarding-contracts/card";

/** The buyer and card contracts are Identity's contracts package's: this
 *  package re-exports them for its clients. */
export * from "@libs/identity-onboarding-contracts/buyer";
export * from "@libs/identity-onboarding-contracts/card";

/** `brandId` is computed when a saved card is read, from the vault's brand
 *  string (`cardBrandIdOf`); no column holds it. */
export { cardBrandIdOf } from "@libs/utils/card-brands";
export type CardSummary = {
  id: string;
  brand: string;
  brandId: CardBrandId;
  last4: string;
  expiryMonth: number;
  expiryYear: number;
  cvcExpiresAt?: string | null;
};
export type BuyerIdentity = {
  email: string;
  details: Partial<Buyer>;
  cards: CardSummary[];
  vendorAccount: { email: string; status: "pending" | "established" } | null;
  /** Whether the buyer already has an agent-mail address on a domain no
   *  vendor refuses, which a new vendor account can share: a checkout then
   *  has no account to open ahead of Pay. False for a buyer whose only
   *  addresses some vendor refuses, whose checkout asks and is told
   *  `has_address` by a vendor that takes one. Absent from a server before
   *  it was served: nothing is opened. */
  agentMailAddress?: boolean;
};

export type CardTransport = {
  beginCardCapture(cardId?: string): Promise<CardCapture>;
  completeCardCapture(input: CaptureComplete): Promise<CardSummary>;
};
